import { withInstall } from '../utils'
import _NpButton from './src/np-button.vue'

export const NpButton = withInstall(_NpButton)
export default NpButton

export * from './src/props'
